import { render, staticRenderFns } from "./ClientsDetails.vue?vue&type=template&id=1662317c&"
import script from "./ClientsDetails.vue?vue&type=script&lang=js&"
export * from "./ClientsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports